module.exports = __webpack_public_path__ + "static/media/trailer.5ae52180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trailer.png
// module id = 462
// module chunks = 0